import "./App.css";
import Signin from "./components/common/Signin";
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";
import AdminMenu from "./components/admin/AdminMenu";
import StaffInformationRegister from "./components/admin/StaffInformationRegister";
import StaffInformationManagement from "./components/admin/StaffInformationManagement";
import EvaluationPeriodChange from "./components/admin/EvaluationPeriodChange";
import UpdateEvaluationList from "./components/admin/UpdateEvaluationList";
import UpdateValuationCategoryMaster from "./components/admin/UpdateValuationCategoryMaster";
import UpdateValuationItemMaster from "./components/admin/UpdateValuationItemMaster";
import UpdateSticker from "./components/admin/UpdateSticker";
import Evaluation from "./components/student/Evaluation";
import PlaningSheet from "./components/student/PlanningSheet";
import EvaluationComparison from "./components/student/EvaluationComparison";
import StudentMenu from "./components/student/StudentMenu";
import EvaluationConfirm from "./components/student/EvaluationConfirm";
import StaffMenu from "./components/staff/StaffMenu";
import StudentInformationRegister from "./components/staff/StudentInformationRegister";
import StudentInformationManagement from "./components/staff/StudentInformationManagement";
import WebEvaluation1 from "./components/common/WebEvaluation1";
import WebEvaluation2 from "./components/common/WebEvaluation2";
import EvaluationImplement from "./components/staff/EvaluationImplement";
import EvaluationAnalysis from "./components/staff/EvaluationAnalysis";
import DataAnalysis from "./components/staff/DataAnalysis";
import Printing from "./components/staff/Printing";

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/">
        <Route index element={<Signin />} />
        <Route path="/AdminMenu" element={<AdminMenu />} />
        <Route path="/StaffInformationRegister" element={<StaffInformationRegister />} />
        <Route path="/StaffInformationManagement" element={<StaffInformationManagement />} />
        <Route path="/EvaluationPeriodChange" element={<EvaluationPeriodChange />} />
        <Route path="/UpdateEvaluationList" element={<UpdateEvaluationList />} />
        <Route path="/UpdateValuationCategoryMaster" element={<UpdateValuationCategoryMaster />} />
        <Route path="/UpdateValuationItemMaster" element={<UpdateValuationItemMaster />} />
        <Route path="/UpdateSticker" element={<UpdateSticker />} />
        <Route path="/Evaluation" element={<Evaluation />} />
        <Route path="/PlaningSheet" element={<PlaningSheet />} />
        <Route path="/EvaluationComparison" element={<EvaluationComparison />} />
        <Route path="/StudentMenu" element={<StudentMenu />} />
        <Route path="/EvaluationConfirm" element={<EvaluationConfirm />} />
        <Route path="/StaffMenu" element={<StaffMenu />} />
        <Route path="/StudentInformationRegister" element={<StudentInformationRegister />} />
        <Route path="/StudentInformationManagement" element={<StudentInformationManagement />} />
        <Route path="/WebEvaluation1" element={<WebEvaluation1 />} />
        <Route path="/WebEvaluation2" element={<WebEvaluation2 />} />
        <Route path="/EvaluationImplement" element={<EvaluationImplement />} />
        <Route path="/EvaluationAnalysis" element={<EvaluationAnalysis />} />
        <Route path="/DataAnalysis" element={<DataAnalysis />} />
        <Route path="/Printing" element={<Printing />} />
      </Route>
    )
  );

  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
